<div class="not-found-container">
    <div class="content">
        <div class="badge">404</div>
        <h2>Page Not Found</h2>
        <p class="message">We couldn't find the page you're looking for. It may have been moved or deleted.</p>

        <div class="actions">
            <a [routerLink]="'/'" class="btn primary">Home</a>
            <!-- <a routerLink="/launch" class="btn outline">Launch</a> -->
        </div>

        <div class="hint">If you think this is an error, contact your administrator.</div>
    </div>
</div>